import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import create from "../../assets/img/message/plus-icon.svg"
import user from "../../assets/img/message/user-icon.svg"
import sendm from "../../assets/img/message/send-msg.svg";
import filesu from "../../assets/img/message/file.svg";
import "../../assets/css/text-limit.css";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import CreateGroup from "./CreateGroup";
import { checkCharacterLimit } from "../../utils/textLimiter";
import ConfirmBlockUser from "./ConfirmBlockUser";
import ResponsePopup from "../../commonComponents/responseSucessPopup";
import {
  getInboxUsers, getAllChatRequests, acceptChatRequest,
  rejectChatRequest, getChatHistory, saveChat,
  getAllFavouriteUsers, saveBlockStatus, removeGroupChatUser,
  getGroupChatHistory, saveGroupChatMessage
} from "../../services/apiMessage";
import { API } from "../../services/api";
import { formatDistanceToNow } from 'date-fns';
const Messages = () => {
  const MAX_MESSAGE_LENGTH = 2000;
  const [characterLimit, setCharacterLimit] = useState({
    isOverLimit: false,
    remaining: MAX_MESSAGE_LENGTH,
    limitedText: ''
  });
  const navigate = useNavigate();
  const [msgGroupId, setGroupId] = useState("");
  const [messageType, seMessagetype] = useState('home');
  const [Requests, setRequests] = useState([]);
  const [ChatHistory, setchatHistory] = useState([]);
  const [ReceiverName, setReceiverName] = useState("");
  const [profile_image_url, set_profile_image_url] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [activeUserId, setActiveUserId] = useState(null);
  const [AllFavourites, setAllFavourites] = useState([]);
  const [Inboxusers, setInboxusers] = useState([]);
  const [open, setOpen] = useState(false);
  const[ChatBlockType,setChatBlockType]= useState(false);
  const[isSucess,SetSucess]=useState(false);
  const[ResponseMessage,SetResponseMessage]=useState("");
  const [blockType, setBlockType] = useState("");
  const [blockUserName, setBlockUser] = useState("");
  const [blockedUsers, setBlockedusers] = useState("");
  const [isConfirm, setConfirm] = useState(false);
  const userData = JSON.parse(localStorage.getItem('userData'));
  const [storedReceiverId, setstoredReceiverId] = useState(localStorage.getItem("receiverId") || '');
 const [inboxSearchKey, setInboxSearchKey] = useState("");
  const [requestUserId, setRequestUserId] = useState("");
  const [requestCount, setRequestCount] = useState("");
  const [blockUserId, setBlockUserId] = useState("");
  const chatContainerRef = useRef(null);
  const [key, setKey] = useState('home');
  const [isChatUserStatus, setisChatUserStatus] = useState(localStorage.getItem("isChatUserStatus") || '');
  // isChatUserStatus ==0 ,request not sent,1=>reuest pending,2=>request accepted,3=>rejected
  useEffect(() => {
    fetchAllChatRequests();
    fetchAllInboxusers();
    //fetchAllFavouriteUsers();
    if (storedReceiverId)
      fetchChatHistory(storedReceiverId);
   
  }, [userData._id, storedReceiverId]);
  useEffect(() => {
    scrollToBottom();
  }, [ChatHistory]);

  useEffect(() => {
    fetchAllFavouriteUsers();
  }, [userData._id]);


  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  };
  const cretegroup = async () => {
    setOpen(true);
  }
  const ClosePopup = () => {
    setOpen(false);

  }
  const handleBlock = async (blockuserid, blockType) => {
    let response;
     
    if (blockType === "exit"){
       response = await removeGroupChatUser({ userid: userData._id, chatgroupid: blockuserid });
      setChatBlockType("");
    }
     
    else{
         if(blockType == "unblock")
          setChatBlockType("");
        else
           setChatBlockType("exit");
         response = await saveBlockStatus({ userid: userData._id, blockuserid: blockuserid });
    }
      
    
    
    setConfirm(false);
    fetchAllInboxusers();
   /* const isBlocked = checkIfUserIsBlocked(blockedUsers, blockuserid);
    alert(isBlocked);
      if(isBlocked)
       setChatBlockType("exit");*/
  }

  const BlockUser = async (blockuserId, firstName, lastName, type) => {
    setBlockUserId(blockuserId);
    setBlockType(type);
    setBlockUser(firstName + " " + lastName);
    setConfirm(true);
    if(type === "block")
    setChatBlockType("exit");

  }


  const fetchAllChatRequests = async () => {
    let response = await getAllChatRequests({ userid: userData._id });
    if (response.status === true) {
      setRequests(response.requests || []);
      setRequestCount(response.requests.length);
    }
  }


  const fetchAllFavouriteUsers = async () => {
    let response = await getAllFavouriteUsers({ userid: userData._id });
    if (response.status === true) {
      setAllFavourites(response.favouriteUsers || []);
    }

  }

  const fetchAllInboxusers = async (searchKey = inboxSearchKey) => {
    let response = await getInboxUsers({ userid: userData._id,searchkey:searchKey });
    if (response.status === true) {
      setInboxusers(response.inboxUsers || []);
      setBlockedusers(response.blockedUsers || []);
      if(storedReceiverId=="" && msgGroupId=="" && (response.inboxUsers.length >0)){
        /* storedReceiverId is null when user directly click the chat icon, storedReceiverId gets value
         when we come through a user profile */
         if(response.inboxUsers[0].isGroupMessage === false){
              if(response.inboxUsers[0].senderUserId === userData._id){
              setstoredReceiverId(response.inboxUsers[0].receiverUserId);
              fetchChatHistory(response.inboxUsers[0].receiverUserId);
            }
            else
              setstoredReceiverId(response.inboxUsers[0].senderUserId);
            fetchChatHistory(response.inboxUsers[0].senderUserId);
          }
          else{
            fetchChatGroup(response.inboxUsers[0].group._id);

          }

         }
       
        
    }
  }
  const fetchChatGroup =async(groupid)=>{
     let response = await getGroupChatHistory({ "groupid": groupid });
      setchatHistory(response.chat || []);
      setReceiverName(response.chatGroup?.name);
      set_profile_image_url(user);
      setGroupId(groupid); // if it is a group
      setstoredReceiverId("");
  }
  const RequestStatus = async (userId) => {
    setRequestUserId(userId);
    setstoredReceiverId(userId);
    fetchChatHistory(userId);
    setGroupId("");
    seMessagetype("");
  }
  
  const fetchChatHistory = async (ReceiverId) => {
    let response = await getChatHistory({ userid: userData._id, receiverid: ReceiverId, offset: 0, limit: 2000 });
    if (response.status === true) {
      if (response.receiverUser.profileSettings.isPrivateProfile === false && response.receiverUser.profileSettings.showprofileImage === true)
        set_profile_image_url(response.receiverUser?.profileImage?.url
          ? process.env.REACT_APP_IMAGE_URL + response.receiverUser.profileImage.url
          : user);
      else
        set_profile_image_url(user);
      setReceiverName(
      (response.receiverUser?.firstName || '') + 
      (response.receiverUser?.lastName ? ' ' + response.receiverUser.lastName : '')
    );
      setchatHistory(response.chat || []);


    }
  }


  const AcceptRejectRequest = async (type, senderid, receiverid) => {
    let response;

    if (type === "accept") {

      response = await acceptChatRequest({ senderid: senderid, receiverid: receiverid });
      setisChatUserStatus(2);

    }

    else {
      response = await rejectChatRequest({ senderid: senderid, receiverid: receiverid });
      window.location.reload();
    }


    setRequestUserId("");

    fetchAllChatRequests();
  }
  const listChatHistory = async (friendid, type) => {
    setChatBlockType("");
    setActiveUserId(friendid);
    setisChatUserStatus("");
    seMessagetype(type);
    if (type === "group") {
      let response = await getGroupChatHistory({ "groupid": friendid });
      setchatHistory(response.chat || []);
      setReceiverName(response.chatGroup?.name);
      set_profile_image_url(user);
      setGroupId(friendid); // if it is a group
      setstoredReceiverId("");
    } else {
      // fetchChatHistory(friendid);
      setGroupId("");
      setstoredReceiverId(friendid);
    }

  }
  const listBlockchatHistroy =async(friendid)=>{
    // need to set setChatBlockType ,need not show the text area to enter message
      setChatBlockType("exit");
      setstoredReceiverId(friendid);
     setActiveUserId("");
     setisChatUserStatus("");
      setGroupId("");
    fetchChatHistory(friendid);

  }
  const ExitGroup = async (groupid, groupname) => {
    setChatBlockType("exit")
    setBlockUserId(groupid);
    setBlockType('exit');
    setBlockUser("from " + groupname);
    setConfirm(true);


  }

  useEffect(() => {
    const limitInfo = checkCharacterLimit(message, MAX_MESSAGE_LENGTH);
    setCharacterLimit(limitInfo);
  }, [message]);

  const sendMessage = async () => {
    if (!message.trim()) {
      setError('Message cannot be empty!');
      return;
    }
    if (characterLimit.isOverLimit) {
      setError('Message exceeds character limit!');
      return;
    }
    let response;
    if (messageType === "group")
      response = await saveGroupChatMessage({ userid: userData._id, groupid: msgGroupId, message: message });
    else
      response = await saveChat({ userid: userData._id, receiverid: storedReceiverId, message: message });


    if (response.status === true) {

      const newMessage = {
        senderUserId: userData._id,
        message: message,
        createdAt: new Date().toISOString(),
        isNew: true
      };
      setchatHistory(prevChat => [...prevChat, newMessage]);
      setMessage('');
      setError('');
    }
    else{

      SetSucess(true);
      SetResponseMessage(response.message);

    }

  }
  
  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <div className="hd-breadcums">
            <h3 className="main-heading">Message</h3>
          </div>
          <div className="messagewrapper p-0">
            <div className="message_list">
              <div className="message-header">
                <button className="create-message-btn" onClick={() => cretegroup()}>
                  <img src={create} alt="test" className="create-msg" />
                  Create Group Messages</button>
              </div>

              <div className="message-wrapper-tabs-main">
                <Tabs id="controlled-tab-example" activeKey={key} onSelect={(k) => setKey(k)} className="mt-3">
                  <Tab eventKey="profile" title="Favorites">
                    {/*<div className="search-box">
                      <input type="search" className="search-now" placeholder="Search contact"  ></input>
                    </div>*/}
                    <div className="message-list-group">
                      {
                        (AllFavourites.length > 0) && (
                          AllFavourites.map((fav, index) => (
                            <div className="message-itm msg-curso active" key={index} onClick={() => listChatHistory(fav.favouriteMemberId._id, 'individual')}>
                              {
                                fav.favouriteMemberId.profileSettings ?
                                  (fav.favouriteMemberId.profileSettings.isPrivateProfile === false && fav.favouriteMemberId.profileSettings.showprofileImage === true) ?
                                    <img src={
                                      fav.favouriteMemberId?.profileImage?.url
                                        ? API.uploadFilePath + fav.favouriteMemberId?.profileImage?.url
                                        : user
                                    } alt="test" className="user-thumb" />
                                    : <img src={user} alt="test" className="user-thumb" />
                                  : <img src={user} alt="test" className="user-thumb" />
                              }

                              <div className="name_details d-flex flex-column">
                                <div className="name_time d-flex">
                                  <h6>{fav.favouriteMemberId.firstName} {fav.favouriteMemberId.lastName}</h6>
                                  
                                </div>
                                
                              </div>
                             
                            </div>
                          )
                          )
                        )
                      }



                    </div>
                  </Tab>
                  <Tab eventKey="home" title="Inbox">
                    <div className="search-box">
                      <input type="search" className="search-now" placeholder="Search contact"  onChange={(e) =>
                        {e.preventDefault();
                          const newValue = e.target.value;
                          setInboxSearchKey(newValue);
                          fetchAllInboxusers(newValue);
                        } }></input>
                    </div>
                    <div className="message-list-group">
                      {Inboxusers.length > 0 && (
                        Inboxusers.map((inboxuser, index) => (
                          <React.Fragment key={index}>
                            {inboxuser.senderUserId === userData._id &&
                              Object.keys(inboxuser.group).length == 0 && (
                                <div className={`message-itm ${inboxuser.receiver._id === activeUserId ? 'active-user' : ''}`} onClick={() => listChatHistory(inboxuser.receiver._id, 'individual')}>
                                  {inboxuser.receiver?.profileSettings?.isPrivateProfile === false && inboxuser.receiver?.profileSettings?.showprofileImage === true ? (
                                    <img src={
                                      inboxuser.receiver?.profileImage?.url
                                        ? API.uploadFilePath + inboxuser.receiver?.profileImage?.url
                                        : user
                                    } alt="test" className="user-thumb" />

                                  ) : (<img src={user} alt="test" className="user-thumb" />)}
                                   {
                                    inboxuser.senderUserId!==userData._id && inboxuser.readStatus === false &&(<span className="new" > </span>)
                                   }
                                  
                                  <div className="name_details d-flex flex-column">
                                    <div className="name_time d-flex">
                                      <h6>{inboxuser.receiver.firstName} {inboxuser.receiver.lastName}</h6>
                                      <span className="time_value">
                                        {formatDistanceToNow(new Date(inboxuser.createdAt), { addSuffix: true })}
                                      </span>
                                    </div>
                                    <p className="msg-sample">{inboxuser.message}</p>
                                  </div>
                                  <button onClick={() => BlockUser(inboxuser.receiver._id, inboxuser.receiver.firstName, inboxuser.receiver.lastName || '', 'block')}><i className="bi bi-three-dots-vertical"></i></button>
                                </div>
                              )}

                            {inboxuser.receiverUserId === userData._id &&
                              Object.keys(inboxuser.group).length == 0 && (
                                <div className={`message-itm ${inboxuser.sender._id === activeUserId ? 'active-user' : ''}`} onClick={() => listChatHistory(inboxuser.sender._id, 'individual')}>
                                  {inboxuser.sender?.profileSettings?.isPrivateProfile === false && inboxuser.sender?.profileSettings?.showprofileImage === true ? (
                                    <img src={
                                      inboxuser.sender?.profileImage?.url
                                        ? API.uploadFilePath + inboxuser.sender?.profileImage?.url
                                        : user
                                    } alt="test" className="user-thumb" />

                                  ) : (<img src={user} alt="test" className="user-thumb" />)}
                                  {
                                    inboxuser.senderUserId!==userData._id && inboxuser.readStatus === false &&(<span className="new" > </span>)
                                   }
                                  
                                  <div className="name_details d-flex flex-column">
                                    <div className="name_time d-flex">
                                      <h6>{inboxuser.sender.firstName} {inboxuser.sender.lastName}</h6>
                                      <span className="time_value">
                                        {formatDistanceToNow(new Date(inboxuser.createdAt), { addSuffix: true })}
                                      </span>
                                    </div>
                                    <p className="msg-sample">{inboxuser.message}</p>
                                  </div>
                                  <button onClick={() => BlockUser(inboxuser.sender._id, inboxuser.sender.firstName, inboxuser.sender.lastName || '', 'block')}><i className="bi bi-three-dots-vertical"></i></button>
                                </div>
                              )}

                            {
                              Object.keys(inboxuser.group).length > 0 && (
                                <div className={`message-itm ${inboxuser.group._id === activeUserId ? 'active-user' : ''}`} onClick={() => listChatHistory(inboxuser.group._id, 'group')}>

                                  <img src={user} alt="test" className="user-thumb" />
                                  <div className="name_details d-flex flex-column">
                                    <div className="name_time d-flex">
                                      <h6>{inboxuser.group.name}</h6>
                                      <span className="time_value">
                                        {formatDistanceToNow(new Date(inboxuser.createdAt), { addSuffix: true })}
                                      </span>
                                    </div>
                                    <p className="msg-sample">{inboxuser.message}</p>
                                  </div>
                                  <button onClick={() => ExitGroup(inboxuser.group._id, inboxuser.group.name)}><i className="bi bi-three-dots-vertical"></i></button>
                                </div>
                              )}
                          </React.Fragment>
                        ))
                      )}

                      {

                        blockedUsers.length > 0 && (
                          <h5 className="BlockedContacts" >Blocked Contacts</h5>
                        )


                      }
                      {blockedUsers.length > 0 && (
                        blockedUsers.map((block, index) => (
                          <>
                            <div className="message-itm blocked" key={index} onClick={()=>listBlockchatHistroy(block.friendId._id)}>
                              {block.friendId?.profileSettings?.isPrivateProfile === false && block.friendId?.profileSettings?.showprofileImage === true ? (
                                <img src={
                                  block.friendId?.profileImage?.url
                                    ? API.uploadFilePath + block.friendId?.profileImage?.url
                                    : user
                                } alt="test" className="user-thumb" />

                              ) : (<img src={user} alt="test" className="user-thumb" />)}
                              <div className="name_details d-flex flex-column">
                                <div className="name_time d-flex">
                                  <h6>{block.friendId.firstName}{block.friendId.lastName}</h6>
                                  
                                </div>

                                
                              </div>
                              <button onClick={() => BlockUser(block.friendId._id, block.friendId.firstName, block.friendId.lastName || '', 'unblock')}><i class="bi bi-three-dots-vertical"></i></button>
                            </div>
                          </>

                        )))}


                    </div>
                  </Tab>
                  <Tab eventKey="contact" title={
                    <div className="d-flex align-items-center">
                      Requests {
                        requestCount > 0 && (<span className="badge bg-danger ms-2">{requestCount}</span>)
                      }

                    </div>
                  }>

                    
                    <div className="message-list-group">


                      {Requests.length > 0 && (
                        Requests.map((item, index) => (

                          <div className="message-itm active" key={index} onClick={() => RequestStatus(item.user[0]._id)}>
                            {item.user[0]?.profileSettings?.isPrivateProfile === false && item.user[0]?.profileSettings?.showprofileImage === true ? (
                              <img src={
                                item.user[0]?.profileImage?.url
                                  ? API.uploadFilePath + item.user[0]?.profileImage?.url
                                  : user
                              } alt="test" className="user-thumb" />

                            ) : (<img src={user} alt="test" className="user-thumb" />)}
                            <div className="name_details d-flex flex-column">
                              <span className="new" > </span>
                              <div className="name_time d-flex">
                                <h6>{item.user[0].firstName}{item.user[0].lastName}</h6>
                                <span className="time_value" >{formatDistanceToNow(new Date(item.createdAt), { addSuffix: true })}</span>
                              </div>
                              <p className="msg-sample" >{item.message}</p>
                            </div>

                          </div>

                        )))}

                    </div>
                  </Tab>
                </Tabs>



              </div>


            </div>
            {(ChatHistory.length > 0 || storedReceiverId !== '') && (
              <div className="message-details">
                <div className="message-header">
                  <div className="message-itm p-0">
                    <img src={profile_image_url} alt="test" className="user-thumb" />
                    <div className="name_details d-flex flex-column">
                      <div className="name_time d-flex">
                        <h6 className="detail-name" >{ReceiverName}</h6>
                      </div>
                      
                    </div>
                    <button className="msg-close" ><i class="bi bi-x-lg"></i></button>
                  </div>
                </div>
                <div className="chat-area">
                  <div className="scroll-auto-m" ref={chatContainerRef}>
                    {ChatHistory.map((item, index) => {
                      // Normalize the sender ID first
                      const senderId = typeof item.senderUserId === 'object'
                        ? item.senderUserId?._id
                        : item.senderUserId;

                      const isCurrentUser = senderId === userData._id;

                      return (
                        <React.Fragment key={index}>
                          {!isCurrentUser && (
                            <div className="message-itm chat-itm send">
                              {item?.isGroupMessage === false ? (
                                <img src={profile_image_url} alt="test" className="user-thumb" />
                              ) : (
                                typeof item.senderUserId === 'object' &&
                                  item.senderUserId?.profileSettings?.isPrivateProfile === false &&
                                  item.senderUserId?.profileSettings?.showprofileImage === true ? (
                                  <img
                                    src={
                                      item.senderUserId?.profileImage?.url
                                        ? API.uploadFilePath + item.senderUserId.profileImage?.url
                                        : user
                                    }
                                    alt="test"
                                    className="user-thumb"
                                  />
                                ) : (
                                  <img src={user} alt="test" className="user-thumb" />
                                )
                              )}
                              <div className="message-single d-flex flex-column">
                                <div className="name_time d-flex">
                                  <h6 className="time">
                                    {item.isNew ? "just now" : formatDistanceToNow(new Date(item.createdAt), { addSuffix: false })}
                                  </h6>
                                </div>
                                <span className="chat-content">{item.message}</span>
                              </div>
                            </div>
                          )}

                          {isCurrentUser && (
                            <div className="message-itm chat-itm replay">
                              {userData.profileSettings?.isPrivateProfile === false &&
                                userData.profileSettings?.showprofileImage === true ? (
                                <img
                                  src={
                                    userData?.profileImage?.url
                                      ? API.uploadFilePath + userData.profileImage?.url
                                      : user
                                  }
                                  alt="test"
                                  className="user-thumb"
                                />
                              ) : (
                                <img src={user} alt="test" className="user-thumb" />
                              )}
                              <div className="message-single d-flex flex-column">
                                <div className="name_time d-flex">
                                  <h6 className="time">
                                    {item.isNew ? "just now" : formatDistanceToNow(new Date(item.createdAt), { addSuffix: false })}
                                  </h6>
                                </div>
                                <span className="chat-content">{item.message}</span>
                              </div>
                            </div>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </div>

                  {((storedReceiverId === requestUserId || isChatUserStatus === 1) && msgGroupId === "") && (
                    <div className="action-msg" >
                      <button onClick={() => AcceptRejectRequest('accept', requestUserId, userData._id)}>ACCEPT</button>
                      <button onClick={() => AcceptRejectRequest('reject', requestUserId, userData._id)}>DENY</button>
                    </div>
                  )}
                  
                  {
                    ChatBlockType === 'exit' && (<p>You blocked this contact</p>)
                  }


                  {(storedReceiverId !== requestUserId || msgGroupId !== "") && ChatBlockType !== 'exit' && (
                    <div className="create-msg-box-msg">
                     
                      <div className="form-group w-100">
                        <input
                          type="text"
                          placeholder="Enter Your Message here..."
                          className={`form-control msg-b ${error ? 'is-invalid' : ''}`}
                          value={message}
                          maxLength={MAX_MESSAGE_LENGTH}
                          onChange={(e) => setMessage(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' && !e.shiftKey) {
                              e.preventDefault();
                              sendMessage();
                            }
                          }}
                        />
                        <div className={`character-counter ${characterLimit.isOverLimit ? 'text-danger' : 'text-muted'}`}>
                          {characterLimit.remaining ?? MAX_MESSAGE_LENGTH} characters remaining
                          {characterLimit.remaining <= 0 && (
                            <span className="limit-warning"> (Maximum limit reached)</span>
                          )}
                        </div>
                        {error && <div className="text-danger small mt-1">{error}</div>}
                        <button className="m-send-btn" onClick={sendMessage}> <img src={sendm} alt="test" className="uploadmedia" /> </button>
                      </div>
                    </div>)}


                </div>
              </div>
            )
            }

          </div>
        </div>
      </div>
      <CreateGroup openPop={open} closePop={ClosePopup} fetchAllInboxusers={fetchAllInboxusers}></CreateGroup>
      {isConfirm && (<ConfirmBlockUser
        isConfirm={isConfirm}
        blockUserId={blockUserId}
        handleBlock={handleBlock}
        blockType={blockType}
        blockUserName={blockUserName}
        CancelPopup={() => {
          setConfirm(false);
        }}

      />)}
       {isSucess && (<ResponsePopup 
                            isSucess={isSucess} 
                            CancelPopup={() => { 
                             SetSucess(false);
                            }} 
                            message={ResponseMessage}
                          />)}
     
    </div>

  );
};
export default Messages;